import React 			from 'react';
import PropTypes 	from 'prop-types';
import Slider			from 'react-slick';

import HiddenScroll 	from '../common/_HiddenScroll.jsx';
import FloatingImage 	from '../common/_FloatingImage.jsx';

import {onEscapePress} from '../common/_Utilities.jsx';

const PrevArrow = ({currentSlide, slideCount, children, ...props}) => (
	<button {...props}><i className="fas fa-chevron-left"></i></button>
);

const NextArrow = ({currentSlide, slideCount, children, ...props}) => (
	<button {...props}><i className="fas fa-chevron-right"></i></button>
);

export default class ZoomModal extends React.Component{
	constructor(props) {
		super(props);

		this.state = {
			activeImage: this.props.data.activeImage ? this.props.data.activeImage : 0,
			previousActiveImage: 0,
			fullSize: false,
			scale: 10,
			positionX: 0,
			positionY: 0,
			isZoom: false
		}

		this.slickSettings = {
			dots: false,
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			prevArrow: <PrevArrow />,
			nextArrow: <NextArrow />,
			afterChange: (index) => this.changeSlide(index)
		}
	}

	componentDidMount() {
		this.triggerZoomModal();
		this.jumpToSlide(this.state.activeImage);
		onEscapePress(() => this.props.func.toggleZoomModal());
	}

	componentDidUpdate() {
		onEscapePress(() => this.props.func.toggleZoomModal());
	}

	triggerZoomModal() {
		const modalContainer 	= this.modalContainer;
		const container 			= this.container;
		const image 					= this.image;
		const limitScale 			= {min: 10, max: 30};
		const _this 					= this;
		
		let currentScale 	= this.state.scale;
		let isMouseDown 	= false;
		let initialMouse 	= {x: 0, y: 0};
		let newMouse 			= {x: 0, y: 0};
		let currentMouse	= {x: 0, y: 0};
		let imageSize 		= {w: 0, h: 0};
		let imagePosition = {x: this.state.positionX, y: this.state.positionY};
		let containerInfo = {};
		let padding				= 12;
		let gestureStart 	= 0;

		let startMouse = {x: 0, y: 0};

		function initiateZoom() {
			if(!_this.state.isZoom) {
				_this.setState({isZoom: true});
			}
		}

		function handleGestureStart(e) {
			e.preventDefault();

			gestureStart = currentScale;
		}
		function handleGestureChange(e) {
			e.preventDefault();

			currentScale = gestureStart * e.scale;

			handleTranslate();
		}

		function scaleImage(e) {
			e.preventDefault();
			
			imageSize = {w: image.offsetWidth, h: image.offsetHeight};
			
			const frameX = currentMouse.x - containerInfo.x;
			const frameY = currentMouse.y - containerInfo.y;
			
			image.style.transformOrigin = `${frameX}px ${frameY}px`;

			if(e.deltaY < 0) {
				if(currentScale < limitScale.max) {
					currentScale++;
				}
			}
			if(e.deltaY > 0) {
				if(currentScale > limitScale.min) {
					currentScale--;
				}
			}
			
			handleTranslate();
		}

		function handleTranslate(scale = currentScale, positionX = imagePosition.x, positionY = imagePosition.y) {
			_this.setState({scale: scale, positionX: positionX, positionY: positionY});
		}

		function handleMouseDown(e) {
			if(_this.state.isZoom) {
				startMouse = {x: e.clientX, y: e.clientY};
			}else{
				startMouse = {x: 0, y: 0}
				initiateZoom();
			}

			isMouseDown 	= true;
			imageSize 		= {w: image.offsetWidth * currentScale/10, h: image.offsetHeight * currentScale/10};
			initialMouse 	= {x: e.clientX - newMouse.x, y: e.clientY - newMouse.y};
			containerInfo = {w: container.offsetWidth, h: container.offsetHeight, x: container.offsetTop + modalContainer.offsetTop, y: container.offsetLeft + modalContainer.offsetLeft};
		}

		function handleMouseMove(e) {
			currentMouse = {x: e.clientX, y: e.clientY};

			if(isMouseDown) {
				newMouse.x = currentMouse.x - initialMouse.x;
				newMouse.y = currentMouse.y - initialMouse.y;
				
				imagePosition.x = newMouse.x;
				imagePosition.y = newMouse.y;
				
				if(newMouse.x > (containerInfo.w - padding)) {
					newMouse.x = containerInfo.w - padding;
				}else if(newMouse.y > (containerInfo.h - padding)) {
					newMouse.y = containerInfo.h - padding;
				}else if(newMouse.x < (imageSize.w - padding) * -1){
					newMouse.x = (imageSize.w - padding) * -1;
				}else if(newMouse.y < (imageSize.h - padding) * -1) {
					newMouse.y = (imageSize.h - padding) * -1
				}
				
				handleTranslate();
			}
		}

		function handleMouseUp(e) {
			isMouseDown		= false;
			currentMouse 	= {x: e.clientX, y: e.clientY};

			if(startMouse.x == currentMouse.x && startMouse.y == currentMouse.y) {
				exitZoom();
			}else{
				initialMouse	= {x: newMouse.x, y: newMouse.y};
			}
		}

		function resetData() {
			_this.setState({previousActiveImage: _this.state.activeImage, positionX: 0, positionY: 0});
			initialMouse 	= {x: 0, y: 0};
			newMouse 			= {x: 0, y: 0};
			currentMouse	= {x: 0, y: 0};
			imageSize 		= {w: 0, h: 0};
			imagePosition = {x: 0, y: 0};
		}

		function exitZoom() {
			_this.setState({isZoom: false}, resetData());
		}

		container.addEventListener('wheel', (e) => scaleImage(e));
		container.addEventListener('mousedown', (e) => handleMouseDown(e));
		container.addEventListener('mouseup', (e) => handleMouseUp(e));
		container.addEventListener('mousemove', (e) => handleMouseMove(e));
		container.addEventListener('gesturestart', (e) => handleGestureStart(e));
		container.addEventListener('gesturechange', (e) => handleGestureChange(e));
	}


	render() {
		const {images, activeImage} = this.props.data;

		const thumbnails = images.map((image, key) =>
			<li className={"zoom-modal__thumbnails-item " + (this.state.activeImage == key ? 'zoom-modal__thumbnails-item--active' : '')} key={key} onClick={() => this.jumpToSlide(key)}>
				<FloatingImage classes="zoom-modal__thumbnails-item-image">
					<img src={image}/>
				</FloatingImage>
			</li>
		);

		return (
			<div className="modal">
				<div className="modal__overlay" onClick={() => this.props.func.toggleZoomModal()}></div>
				<div ref={modalContainer => this.modalContainer = modalContainer} className={"modal__content zoom-modal modal__content--sticky-footer"}>
					<i className="far fa-times modal__close zoom-modal__close" onClick={() => this.props.func.toggleZoomModal()}></i>
					<div className={"modal__body zoom-modal__body " + (this.state.isZoom ? ' zoom-modal__body--full-size' : '')}>
						<div ref={container => this.container = container} className={"zoom-modal__image" + (this.state.isZoom ? ' zoom-modal__image--full-size' : '') + (this.state.isZoom ? '' : ' l-hide')}>
							<img ref={image => this.image = image} style={this.state.isZoom ? {transform: `scale(${this.state.scale/10}) translateX(${this.state.positionX}px) translateY(${this.state.positionY}px)`} : null} src={images[this.state.activeImage]}/>
						</div>
						<Slider className={this.state.isZoom ? 'l-hide' : ''} ref={slider => this.slider = slider} {...this.slickSettings}>
							{this.renderMainImages()}
						</Slider>
					</div>
					{thumbnails.length > 1 ?
						<div className="modal__footer zoom-modal__footer">
							<HiddenScroll classes="zoom-modal__thumbnails l-pad-top--null">
								{thumbnails}
							</HiddenScroll>
						</div>
					: null}
				</div>
			</div>
		);
	}

	renderMainImages() 
	{
		const images = this.props.data.images;

		const mainImages = images.map((image, key) => {
			return (
				<FloatingImage key={key}>
					<img src={image} onMouseDown={(e) => this.setState({position: {x: e.clientX, y: e.clientY}})} onMouseUp={(e) => this.shouldTriggerZoomModal(e, key)}/>
				</FloatingImage>
			);
		});

		return mainImages;
	}

	changeSlide(index) {
		this.setState({activeImage: index});

		const thumbnails 		= document.querySelector('.zoom-modal__thumbnails');
		const activeThumb 	= thumbnails.querySelector('.zoom-modal__thumbnails-item--active');
					activeThumb  != null ? thumbnails.scrollLeft = activeThumb.offsetLeft - thumbnails.offsetLeft : 0;
	}

	shouldTriggerZoomModal(e, activeImage) {
		const prev = this.state.position;

		if(e.clientX == prev.x && e.clientY == prev.y) {
			this.setState({isZoom: true, activeImage: activeImage});
		}
	}

	toggleFullSize() {
		this.setState({fullSize: !this.state.fullSize});
	}

	jumpToSlide(slideNum) {
		const prevActive = this.state.activeImage;

		this.setState({activeImage: slideNum, previousActiveImage: prevActive, fullSize: false, scale: 10, positionX: 0, positionY: 0});
		this.slider.slickGoTo(slideNum);
	}
}

ZoomModal.propTypes = {
		data: PropTypes.shape( {
				images:	PropTypes.arrayOf(PropTypes.string)
			,	activeImage: PropTypes.number.isRequired
		}).isRequired
	,	func: PropTypes.shape({
				toggleZoomModal: PropTypes.func.isRequired
		}).isRequired
}